<nb-card>
    <nb-card-header>
        {{title || "Confirmar"}}
    </nb-card-header>
    <nb-card-body>
        {{message}}
    </nb-card-body>
    <nb-card-footer>
        <button nbButton status="primary" class="float-left" (click)="onClickYes()">Si</button>
        <button nbButton status="secondary" class="float-right" (click)="onClickNo()">No</button>
    </nb-card-footer>
</nb-card>
